import {
  attributeTemplatesGet,
  attributeTemplatesCreate,
  attributeTemplatesUpdate,
  attributeTemplatesDelete
} from "@/api/attributeTemplates.api";

import {
  ATTRIBUTE_TEMPLATES_GET,
  ATTRIBUTE_TEMPLATES_CREATE,
  ATTRIBUTE_TEMPLATES_UPDATE,
  ATTRIBUTE_TEMPLATES_DELETE,
  ATTRIBUTE_TEMPLATES_CLEAR
} from "../type";

const state = {
  attributeTemplates: []
};

const getters = {};
const actions = {
  async [ATTRIBUTE_TEMPLATES_GET]({ commit }, lang) {
    try {
      const response = await attributeTemplatesGet(lang);
      commit(ATTRIBUTE_TEMPLATES_GET, response.data.attributeTemplates);
      return response.status;
    } catch (err) {
      return err.response.status;
    }
  },
  async [ATTRIBUTE_TEMPLATES_CREATE](undefined, { lang, data }) {
    try {
      const response = await attributeTemplatesCreate(lang, data);
      return response.data;
    } catch (err) {
      return err.response.status;
    }
  },
  async [ATTRIBUTE_TEMPLATES_UPDATE](undefined, { id, lang, data }) {
    try {
      const response = await attributeTemplatesUpdate(id, lang, data);
      return response.data;
    } catch (err) {
      return err.response.status;
    }
  },
  async [ATTRIBUTE_TEMPLATES_DELETE](undefined, { id }) {
    try {
      const response = await attributeTemplatesDelete(id);
      return response.data;
    } catch (err) {
      return err.response.status;
    }
  }
};

const mutations = {
  [ATTRIBUTE_TEMPLATES_GET](state, refs) {
    state.attributeTemplates = refs;
  },
  [ATTRIBUTE_TEMPLATES_CLEAR](state) {
    state.attributeTemplates = [];
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
